// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"f04395cc","292":"0adda25a","522":"ce579ce8","560":"bb785b9c","711":"4d83ba4f"}[chunkId] + ".chunk.js";
};